<script setup>
import { cdnImageUrl } from '@dpgradio/creative'

const props = defineProps({
  item: Object,
})

const { onDisappear } = useDisappearable()

const tracks = computed(() => props.item.enrichment?.previousTracks.slice(0, 37))

const containerElement = ref(null)
const trackListElements = ref([])

const applyRandomFlip = (element) => {
  gsap
    .timeline()
    .to(element, {
      rotationY: 360,
      duration: 3,
      ease: 'power1.inOut',
    })
    .set(element, { rotationY: 0 })
}

const startRandomFlips = () => {
  setInterval(() => {
    const randomIndex = Math.floor(Math.random() * (trackListElements.value.length - 8))
    const randomTrack = trackListElements.value[randomIndex]
    if (randomTrack) {
      applyRandomFlip(randomTrack)
    }
  }, Math.random() * 5000 + 2000)
}

onMounted(() => {
  gsap.timeline().from(containerElement.value, { opacity: 0, duration: 1 }, '<.5').to(containerElement.value, { opacity: 1, duration: 1 })
  startRandomFlips()
})

onDisappear(async () => {
  await gsap.to(containerElement.value, { opacity: 0, duration: 1 })
})
</script>

<template>
  <div
    v-if="tracks"
    ref="containerElement"
    class="w-full grid grid-cols-8 z-10 overflow-hidden items-center before:h-full before:absolute before:w-full before:bg-gradient-to-b before:from-transparent before:from-0% before:via-transparent before:via-75% before:z-10 before:to-black before:to-95%"
  >
    <div v-for="(track, index) in tracks" ref="trackListElements" :key="track.id" :class="{ 'aspect-square max-w-full': true, 'col-span-2 row-span-2': index === 0 }">
      <img v-if="track.thumbnail" :src="cdnImageUrl(track.thumbnail, 'w800')" class="w-full h-full object-cover" />
    </div>
  </div>
</template>
